module.exports = "/_next/static/media/fdbd362508154e8390370694dbc391ae.svg";